(function () {
  var MAX_READY_ATTEMPTS = 60;
  var retryCount = 0;
  var jqueryBindAttempts = 0;
  var observerBindAttempts = 0;
  var isScheduled = false;
  var isJqueryBound = false;
  var isObserverBound = false;

  function wishlistModeEnabled() {
    var config = window.T4Sconfigs || {};
    var mode = String(config.wishlist_mode || "");

    return mode === "1" || mode === "2";
  }

  function getWishlistModule() {
    var theme = window.T4SThemeSP || {};
    var wishlist = theme.Wishlist || {};

    return typeof wishlist.updateAll === "function" ? wishlist : null;
  }

  function hydrateMiniCartWishlist() {
    var wishlist = getWishlistModule();

    isScheduled = false;

    if (!wishlistModeEnabled()) return;

    if (!wishlist) {
      if (retryCount < MAX_READY_ATTEMPTS) {
        retryCount += 1;
        scheduleHydration(100);
      }
      return;
    }

    retryCount = 0;
    wishlist.updateAll();
  }

  function scheduleHydration(delay) {
    if (isScheduled) return;

    isScheduled = true;
    window.setTimeout(hydrateMiniCartWishlist, delay || 0);
  }

  function scheduleHydrationBurst() {
    scheduleHydration(0);
    window.setTimeout(function () {
      hydrateMiniCartWishlist();
    }, 120);
    window.setTimeout(function () {
      hydrateMiniCartWishlist();
    }, 500);
  }

  function bindJqueryEvents() {
    if (!wishlistModeEnabled()) return;
    if (isJqueryBound) return;

    var $ = window.jQuery_T4NT || window.jQuery;

    if (!$ || !$.fn || !$(document).on) {
      if (jqueryBindAttempts < MAX_READY_ATTEMPTS) {
        jqueryBindAttempts += 1;
        window.setTimeout(bindJqueryEvents, 100);
      }
      return;
    }

    isJqueryBound = true;
    $(document).on("cart:updated update:mini_cart:wishlist", scheduleHydrationBurst);
  }

  function bindMiniCartObserver() {
    if (!wishlistModeEnabled()) return;
    if (isObserverBound || !window.MutationObserver) return;

    var miniCart = document.getElementById("t4s-mini_cart");

    if (!miniCart) {
      if (observerBindAttempts < MAX_READY_ATTEMPTS) {
        observerBindAttempts += 1;
        window.setTimeout(bindMiniCartObserver, 100);
      }
      return;
    }

    isObserverBound = true;
    new MutationObserver(scheduleHydrationBurst).observe(miniCart, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    if (!wishlistModeEnabled()) return;

    scheduleHydrationBurst();
    bindJqueryEvents();
    bindMiniCartObserver();
  }

  document.addEventListener("cart:update:count", scheduleHydrationBurst);
  document.addEventListener("cart:refresh", scheduleHydrationBurst);
  document.addEventListener("cart:refresh:opend", scheduleHydrationBurst);
  window.addEventListener("pageshow", scheduleHydrationBurst);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
